var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBlack24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cchart-area",
    d: "M3.5,4C3.8,4,4,4.2,4,4.5v13C4,17.8,4.2,18,4.5,18h17c0.3,0,0.5,0.2,0.5,0.5v1c0,0.3-0.2,0.5-0.5,0.5h-19 C2.2,20,2,19.8,2,19.5v-15C2,4.2,2.2,4,2.5,4H3.5z M20.7,16.2l-3.5-7.3c-0.1-0.3-0.4-0.3-0.7-0.2l-3.3,2.2L9.9,6.5 c-0.2-0.3-0.6-0.2-0.8,0l-3.4,5.7v4.1H20.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBlack24Dp);
export default __webpack_public_path__ + "static/media/chart_black_24dp.cb3b7a97.svg";
export { ForwardRef as ReactComponent };